$(() => {
    // Verifica hash ao iniciar
    URI.init();
    (<any>$('#p5fw-accessibility-buttons')).p5fwAccessibility();

    //PopUP's
    if ($('#popupModal').length === 1) {
        (<any>$('#popupModal')).modal('show');
    }

    $(document).ready(function () {
        $('.dropdown-toggle').dropdown();
    });

    /*Search*/
    $('.m-s-input').blur(function (e) {
        console.log('blur');
        $('.m-s-button').show();
        $('.m-s-input').css({ 'padding-left': 0, 'padding-right': 0 }).width(35);

        setTimeout(function () {
            $('.m-s-input').hide();
            $('.m-s-button-close').fadeOut();
        }, 500);
    });

    $('.m-s-button').click(function (event) {
        event.stopPropagation();
        $('.m-s-button-close').show();
        $('.m-s-input').show().css({ 'padding-left': 10, 'padding-right': 40 }).width(350).focus();
    });

    $('.m-s-button-close').click(function () {
        let search: any = $('.m-s-input').val();

        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('.m-s-input').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('.m-s-button-close').click();
        }
    });

    // Menu Mobile Search
    $('.m-m-s-button-close').click(function () {
        let search: any = $('.m-m-s-input').val();

        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('.m-m-s-input').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('.m-m-s-button-close').click();
        }
    });

    $('#p5-player-close-btn').click(function () {
        $('.p5-player').slideUp('fast');
        $('.p-p-text').html('');
        $('#sessao_audio_player').attr('src', '');
    });

    $('#p5-live-close-btn').click(function () {
        $('.p5-live').slideUp('fast');
        $('.p-l-text').html('');
        $('.p-l-link').attr('href', '');
    });

    $(document).off('click touchstart', '.p5-play-audio');
    $(document).on('click touchstart', '.p5-play-audio', function (e) {
        e.stopPropagation();

        let text = $(this).attr('ref-text');
        let audio = 'http://assets.novamutum.plenariodigital.net/' + $(this).attr('ref-audio');

        $('.p5-player').slideDown('fast');
        $('.p-p-text').html("<i class='mdi mdi-play'></i> " + text);
        $('#sessao_audio_player').attr('src', audio);
    });

    // $('#sessoes-menu').click(function () {
    //     window.location.href = '/#/home';
    //     setTimeout(function () {
    //         window.location.href = '/#sessoes-container';
    //     }, 1000);
    // });

    $.post('/ws/live', {}, function (res) {
        let result = JSON.parse(res);
        if (result.youtube) {
            $('.p5-live').slideDown('fast');
            $('.p-l-text').html(result.nome);
            $('.p-l-link').attr('href', result.youtube);
        }
    });
});
